import { render, staticRenderFns } from "./onlineBalance.vue?vue&type=template&id=1482c6b2"
import script from "./onlineBalance.vue?vue&type=script&lang=js"
export * from "./onlineBalance.vue?vue&type=script&lang=js"
import style0 from "./onlineBalance.vue?vue&type=style&index=0&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports